import React, { useEffect, useState } from "react";
import UndergraduateIntro from "../components/undergraduate/UndergraduateIntro";
import UndergraduateIntroBanner from "../components/undergraduate/UndergraduateIntroBanner";
import UndergraduateTab from "../components/undergraduate/UndergraduateTab";
import Banner from "../components/Banner";
import { dynamicFailed } from "../hooks/custom/useToast";
import {
  fetchAdmissionPolicy,
  fetchCurriculumDevelopmentTeam,
  fetchSast4YearPlanTab,
  fetchSastAreasOfStudyTab,
  fetchSastBackground,
  fetchSastBackgroundDetails,
  fetchSastCoreCurriculumTab,
  fetchSastDetailsBanner,
  fetchSastHighlightsTab,
  fetchScholarshipsAndFinancial,
} from "../api/UndergraduateProgramsApi";
import {
  IAdmissionPolicyData,
  ICurriculumDevelopmentTeamData,
  ISastBackgroundData,
  ISastBackgroundDetailsData,
  ISastDetailsBannerData,
  ISastTabData,
  IScholarshipsAndFinancialData,
} from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";

const UndergraduatePage = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const [sastBackground, setSastBackground] = useState<ISastBackgroundData[]>(
    [],
  );
  const [sastBackgroundDetails, setSastBackgroundDetails] = useState<ISastBackgroundDetailsData[]>(
    [],
  );
  const [sastDetailsBanner, setSastDetailsBanner] = useState<
    ISastDetailsBannerData[]
  >([]);
  const [sastHighlightsTab, setSastHighlightsTab] = useState<ISastTabData[]>(
    [],
  );
  const [sastCoreCurriculumTab, setSastCoreCurriculumTab] = useState<
    ISastTabData[]
  >([]);
  const [sastAreasOfStudyTab, setSastAreasOfStudyTab] = useState<
    ISastTabData[]
  >([]);
  const [sast4YearPlanTab, setSast4YearPlanTab] = useState<ISastTabData[]>([]);
  const [curriculumDevelopmentTeam, setCurriculumDevelopmentTeam] = useState<
    ICurriculumDevelopmentTeamData[]
  >([]);
  const [admissionPolicy, setAdmissionPolicy] = useState<
    IAdmissionPolicyData[]
  >([]);
  const [scholarshipsAndFinancial, setScholarshipsAndFinancial] = useState<
    IScholarshipsAndFinancialData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchSastBackground(),
      fetchSastBackgroundDetails(),
      fetchSastDetailsBanner(),
      fetchSastHighlightsTab(),
      fetchSastCoreCurriculumTab(),
      fetchSastAreasOfStudyTab(),
      fetchSast4YearPlanTab(),
      fetchCurriculumDevelopmentTeam(),
      fetchAdmissionPolicy(),
      fetchScholarshipsAndFinancial(),
    ])
      .then(
        ([
          sastBackgroundData,
          sastBackgroundDetailsData,
          sastDetailsBannerData,
          sastHighlightsTabData,
          sastCoreCurriculumTabData,
          sastAreasOfStudyTabData,
          sast4YearPlanTabData,
          curriculumDevelopmentTeamData,
          admissionPolicyData,
          scholarshipsAndFinancialData,
        ]) => {
          setSastBackground(sastBackgroundData);
          setSastBackgroundDetails(sastBackgroundDetailsData);
          setSastDetailsBanner(sastDetailsBannerData);
          setSastHighlightsTab(sastHighlightsTabData);
          setSastCoreCurriculumTab(sastCoreCurriculumTabData);
          setSastAreasOfStudyTab(sastAreasOfStudyTabData);
          setSast4YearPlanTab(sast4YearPlanTabData);
          setCurriculumDevelopmentTeam(curriculumDevelopmentTeamData);
          setAdmissionPolicy(admissionPolicyData);
          setScholarshipsAndFinancial(scholarshipsAndFinancialData);
        },
      )
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="Academics" />
      <UndergraduateIntro sastBackground={sastBackground} sastBackgroundDetails={sastBackgroundDetails}/>
      <UndergraduateIntroBanner sastDetailsBanner={sastDetailsBanner} />
      <UndergraduateTab
        sastHighlightsTab={sastHighlightsTab}
        sastCoreCurriculumTab={sastCoreCurriculumTab}
        sastAreasOfStudyTab={sastAreasOfStudyTab}
        sast4YearPlanTab={sast4YearPlanTab}
        curriculumDevelopmentTeam={curriculumDevelopmentTeam}
        admissionPolicy={admissionPolicy}
        scholarshipsAndFinancial={scholarshipsAndFinancial}
      />
    </>
  );
};

export default UndergraduatePage;
